import WizardModalWrapperLayout from 'Views/Page/Content/Modal/Layouts/WizardModalWrapperLayout';
import React from 'react';
import FundingInstructionFundingTypeTemplate
  from 'Views/Page/Content/Templates/FundingInstructionFundingTypeTemplate/FundingInstructionFundingTypeTemplate';

const Layout = () => (
  <WizardModalWrapperLayout>
    <FundingInstructionFundingTypeTemplate />
  </WizardModalWrapperLayout>
);

export default Layout;
